/// <reference path='../../../image-shims.d.ts'/>

import aceIt from './ace-it-feature-image.png';
import kApp from './k-app-feature-image.png';
import tileTap from './tile-tap-feature-image.png';

export default {
  aceIt,
  kApp,
  tileTap,
} as {[key: string]: string};



// WEBPACK FOOTER //
// ./src/components/project-documentations/static/index.ts